<section class="wrapper">
  <div class="wrapper-div">
    <button
      class="sidenav-hamburger-btn"
      (click)="toggleSidenav.emit()"
      (keydown.enter)="toggleSidenav.emit()"
      title="Toggle menu"
    >
      <svg width="60" height="20" class="cursor-pointer">
        <use [attr.xlink:href]="svgPath + 'sprite.svg#toggle-menu'"></use>
      </svg>
    </button>
    <div class="header-comp-logo">
      <img
        class="montralogo2024"
        src="../../../../assets/img/common/login-montra-logo.svg"
        alt="logo"
      />
    </div>
    <div class="header-center" *ngIf="showUniversalFilter">
      <app-universal-filter></app-universal-filter>
    </div>
    <div class="header-menu">
      <button
        *appHasPermission="'AIRA'; global: true"
        (click)="openAira()"
        class="notif-aira"
        [title]="'Aira'"
      >
        <svg width="60" height="20" class="cursor-pointer">
          <use [attr.xlink:href]="svgPath + 'sprite.svg#aira'"></use>
        </svg>
      </button>

      <span class="seprator" *appHasPermission="'AIRA'; global: true">
        <svg width="24" height="24" class="cursor-pointer">
          <use [attr.xlink:href]="svgPath + 'sprite.svg#seperator'"></use>
        </svg>
      </span>

      <button
        *appHasPermission="'Notification'; global: true"
        (click)="toggleNotification()"
        (keydown.enter)="toggleNotification()"
        class="notif-bell"
        [title]="'Notifications'"
      >
        <svg width="24" height="24" class="cursor-pointer">
          <use
            [attr.xlink:href]="svgPath + 'sprite.svg#notification-bell'"
          ></use>
        </svg>
        <i
          *ngIf="showRedDot"
          class="pi pi-envelope p-text-secondary notification-badge"
          pBadge
          style="font-size: 1rem"
          severity="danger"
        ></i>
      </button>

      <span class="seprator" *appHasPermission="'Notification'; global: true">
        <svg width="24" height="24" class="cursor-pointer">
          <use [attr.xlink:href]="svgPath + 'sprite.svg#seperator'"></use>
        </svg>
      </span>

      <app-vehicle-switcher></app-vehicle-switcher>
    </div>
  </div>
</section>
<app-notification-side-drawer
  *appHasPermission="'Notification'; global: true"
  [(visible)]="visible"
  [hasNewNotification]="hasNewNotification"
  (drawerClosed)="onNotificationDrawerClose()"
  (notificationsViewed)="onNotificationsViewed()"
></app-notification-side-drawer>
